var render, staticRenderFns
import script from "./ElSTable.vue?vue&type=script&lang=js&"
export * from "./ElSTable.vue?vue&type=script&lang=js&"
import style0 from "./ElSTable.vue?vue&type=style&index=0&id=7813d392&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7813d392",
  null
  
)

export default component.exports